

/* eslint-disable @typescript-eslint/no-inferrable-types */
 
 
import { Component, OnInit, OnDestroy, signal, ViewChild, AfterViewInit, AfterContentChecked } from '@angular/core';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ClientInformation } from '../../models/client-information';
import { Integration } from '../../models/integration';
import { Server } from '../../models/server';
import { User } from '../../models/user';
import { ClientIntegrationService } from '../../services/client-integration.service';
import { ToastService } from '../../services/toast.service';
import { Subject } from 'rxjs';
import { IdentifierService } from '../../services/identifier.service';
import { ClientContractService } from 'src/app/services/client-contract.service';
import { IntegrationIdentifier } from '../../models/integration-identifier';
import { IntegrationInformation } from 'src/app/models/integration-information';
import { ServerService } from 'src/app/services/server.service';
import { LOSTalkerTitleService } from '../../services/lostalker-title-service.service';
import { TypeConstantService } from 'src/app/services/type-constant.service';
import { DestinationEndpoint } from 'src/app/models/destination-endpoint';
import { CustomSQLQueryService } from '../../services/sql-queries.service';
import { CustomSQLQuery } from '../../models/sql-query';
import { ClientContract } from 'src/app/models/client-contract';
import { IntegrationProcessViewComponent } from 'src/app/features/lt-edit-config/lt-process-data/components/integration-process-view/integration-process-view.component';
import { ClientInfoViewComponent } from '../../features/lt-edit-config/lt-client-info/components/client-info-view/client-info-view.component';
import { getEndpointName } from 'src/app/models/destination-endpoint';
import { isValidClientId, isValidGuid } from 'src/app/utilities/data-utils';
import { EditIntegrationConfigComponent } from '../../features/lt-edit-config/lt-configuration-info/components/edit-integration-config/edit-integration-config.component';
import { MatTabGroup, MatTabChangeEvent } from '@angular/material/tabs';
import { SQLQueriesComponent } from '../sql-queries/sql-queries.component';

@Component({
  selector: 'app-edit-config',
  standalone: false,
  templateUrl: './edit-config.component.html',
  styleUrl: './edit-config.component.scss',
  providers: [ClientIntegrationService, IdentifierService, LOSTalkerTitleService],
})
export class EditConfigComponent implements OnInit, OnDestroy, AfterViewInit, AfterContentChecked {
  @ViewChild('tabstrip') public tabstrip: MatTabGroup;
  @ViewChild('processView') public processViewTab: IntegrationProcessViewComponent;
  @ViewChild('clientInfoViewTab') public clientInfoViewTab: ClientInfoViewComponent;
  @ViewChild('editConfigTab') public editConfigTab: EditIntegrationConfigComponent;
  @ViewChild('queriesTab') public queriesTab: SQLQueriesComponent;
  componentDestroyed$: Subject<boolean> = new Subject();

  client = signal<ClientInformation>(null);
  integration = signal<Integration>(null);
  integrations = signal<Integration[]>(null);
  integrationSelected: boolean = false;

  serverList = signal<Server[]>([]);
  //serverList: Server[];
  destinationEndpoints = signal<DestinationEndpoint[]>([]);
  savingInformation = signal<boolean>(false);

  contractsLoaded = signal<boolean>(false);
  clientContracts = signal<ClientContract[]>(null);
  clientIdentifiers = signal<IntegrationIdentifier[]>(null);
  identifiers = signal<IntegrationIdentifier[]>(null);
  integrationInfo: IntegrationInformation[] = [];
  hasNoIntegrations: boolean = false;
  tabId: number;
  tabSet: boolean = false;

  //#region IdentifierComments
  getShowIdentifiersComments() {
    if (this.identifiers() != null && this.identifiers()?.length > 0) {
      return true;
    }
    return false;
  }
  //#endregion

  //#region IntegrationHasQueries
  customQueries: CustomSQLQuery[];
  //#endregion

  constructor(
    private clientIntegrationService: ClientIntegrationService,
    private serverService: ServerService,
    private identifierService: IdentifierService,
    private clientContractService: ClientContractService,
    private toastService: ToastService,
    private route: ActivatedRoute,
    private location: Location,
    private user: User,
    private router: Router,
    private titleService: LOSTalkerTitleService,
    private typeConstantsService: TypeConstantService,
    private customQueriesService: CustomSQLQueryService,
  ) {

  }

  //Component Initialization Methods Start
  ngOnInit(): void {
    this.typeConstantsService.getAllDestinationEndpoints()
      .subscribe((d) => {
        this.destinationEndpoints.set(d);
      });
  }

  ngAfterContentChecked(): void {
    this.initializeTabstrip();
  }

  ngAfterViewInit(): void {
    setTimeout(_ => this.initializeSetup());
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }

  initializeTabstrip() {
    if (!this.tabSet && this.tabstrip != undefined) {
      //this.tabstrip._tabs.length
      if (this.tabId < this.tabstrip._tabs.length) {
        // good nothing else needs to be done
      }
      else if (this.tabId >= this.tabstrip._tabs.length) {
        window.history.replaceState({}, '', `/editConfigV2/${this.client().clientInformationId}/${this.integration().integrationId}/0`);
      }
      else {
        this.tabId = 0;
      }
      this.tabSet = true;
    }
  }

  initializeSetup(): void {
    this.route.params
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe((params) => {
        this.populateClientDetails(params);
      });
  }

  populateClientDetails(params: Params): void {
    if (params['clientInfoId']) {
      this.clientIntegrationService
        .getClientByInformationId(params['clientInfoId'])
        .subscribe({
          next: (c) => {
            this.initializeClient(params, c);
          },
          error: (_error) => {
            this.router.navigate(['/clients']);
          },
        });
    }
    else if (this.isValidClientId(params['client'])) {
      this.clientIntegrationService
        .getClientById(params['client'])
        .subscribe({
          next: (c) => {
            this.initializeClient(params, c);
          },
          error: (_error) => {
            this.router.navigate(['/clients']);
          },
        });
    }
    else if (params['client'] != undefined) {
      this.clientIntegrationService
        .getClientByName(params['client'])
        .subscribe({
          next: (c) => {
            this.initializeClient(params, c);
          },
          error: (_error) => {
            this.router.navigate(['/clients']);
          },
        });
    }
    else {
      this.toastService.toastCreate('Route Parameters not Found', 'Warning', {
        autoClose: false,
      });
      this.router.navigate(['/clients']);
    }

    this.tabId = params['tab'];
    if (this.tabId == null) {
      this.tabSet = true;
      this.tabId = 0;
    }
  }

  initializeClient(params: Params, c: ClientInformation): void {
    this.client.set(c);
    this.titleService.setUpTitle('Client - ' + this.client().clientDisplayName);

    this.clientIntegrationService
      .getIntegrationsByClientInfoId(this.client().clientInformationId)
      .subscribe((i) => {
        this.integrations.set(i);
        this.configureIntegrationDetails(params);
      });
  }

  setIntegration(i: Integration) {
    this.integration.set(i);
  }

  configureIntegrationDetails(params: Params): void {
    this.serverService.getAllServersInformation().subscribe((s) => {
      this.serverList.set(s.sort((s1, s2) => Number.parseInt(s1.serverId) - Number.parseInt(s2.serverId)));
      
      if (this.integrations().length > 0) {
        if (params['integration'] != null) {
          if (this.isValidGuid(params['integration'])) {
            this.setIntegration(this.integrations().find((x) => x.integrationId == params['integration']));
          }
          else {
            this.setIntegration(this.integrations().find((x) => x.name == params['integration']));
          }

          if (this.integration() != null) {
            this.selectIntegration(this.integration());
          }
          else {
            this.toastService.toastCreate('Integration ' + params['integration'] + ' not found.', 'Warning', {
              autoClose: false,
            });
            this.setIntegration(this.integrations()[0]);
            this.selectIntegration(this.integration());
          }

        } else {
          this.setIntegration(this.integrations()[0]);
          this.selectIntegration(this.integration());
        }
      } else {
        this.hasNoIntegrations = true;
      }

      this.getContractsAndIdentifiers();
    });
  }

  getContractsAndIdentifiers(): void {
    //Check for contracts with bad identifiers

    forkJoin({
      contracts: (this.clientContractService.getAllClientContractsByClientInfo(this.client().clientInformationId)),
      identifiers: (this.identifierService.getIntegrationIdentifiersByClientInformation(this.client().clientInformationId)),
    })
      .subscribe(({ contracts, identifiers }) => {
        this.clientContracts.set(contracts);
        this.contractsLoaded.set(true);
        this.clientIdentifiers.set(identifiers);
        for (const contract of contracts) {
          if (!contract.disabled && !this.hasNoIntegrations && identifiers.findIndex((x) => x.identifierIdValue == contract.identifierIdValue && x.destinationId == contract.destinationEndpointId) == -1) {
            this.toastService.toastCreate('No identifier matching contract ' + contract.identifierIdValue + '.', 'Warning', {
              autoClose: false,
            });
          }
        }
      });

  }

  deleteClient(): void {
    this.savingInformation.set(true);

    this.clientIntegrationService.deleteClient(this.client()).subscribe(() => {
      this.toastService.toastCreate('Client ' + this.client().clientDisplayName + ' deleted.', 'Success', {
        autoClose: true,
        keepAfterRouteChange: true,
      });
      this.router.navigate(['/clients']);
      this.savingInformation.set(false);
    });
  }

  handleSelectNewIntegration(i: Integration) {
    this.selectNewIntegration(i);
  }

  getActiveTabId(): number {
    if (this.tabstrip != null) {
      return this.tabstrip.selectedIndex;
    }
    else {
      return 0;
    }
  }

  selectNewIntegration(i: Integration) {
    // Update URL with link directly to integration
    window.history.replaceState({}, '', `/editConfigV2/${this.client().clientInformationId}/${i.integrationId}/${this.getActiveTabId() ?? '0'}`);

    if (this.processViewTab != undefined) {
      this.processViewTab.showProcessDataCardView();
    }

    this.setIntegration(i);

    this.selectIntegration(i);
  }

  selectIntegration(i: Integration): void {
    this.titleService.setUpTitle('Client - ' + this.client().clientDisplayName + ' - ' + i.name);

    this.integrationSelected = true;

    this.identifierService
      .getIntegrationIdentifiers(this.integration().integrationId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(data => {
        this.identifiers.set(data);
        if (this.identifiers() != null && this.identifiers().length > 0) {
          this.integrationInfo = [];
          this.identifiers().forEach(id => {
            this.integrationInfo.push(new IntegrationInformation(i, id));
          });
        }
      });

    this.customQueriesService
      .getAllCustomQueriesByIntegration(this.integration().integrationId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(data => {
        this.customQueries = data;
      });
  }

  //Component Initialization Methods End

  //Configuration Information Methods Start


  //#region DeleteIntegration
  handleDeleteIntegration(i: Integration) {
    this.deleteIntegration(i);
  }

  deleteIntegration(i: Integration = null): void {
    this.savingInformation.set(true);

    const confirmMsg =
      'Are you sure you want to delete the selected integration? All existing Errors, RunTimes, Pushbacks, Custom SQL, Failed Loans, and Integration Mappings will be deleted. If it is the only integration for the client, the client will be hidden from display by default.';
    if (window.confirm(confirmMsg)) {
      this.clientIntegrationService.deleteIntegration(i).subscribe({
        next: (_value) => {
          let toastMessage = 'Successfully deleted integration (' + i.name + ')';
          if (this.integrations().length == 1) {
            this.client.update(c => ({ ...c, uiDisplay: false }));
            this.clientIntegrationService.updateClient(this.client()).subscribe({
              next: (_value) => {
                // on success
                toastMessage += ' and client hidden.';
                // on success
                this.toastService.toastCreate(toastMessage, 'Success', {
                  autoClose: false,
                  keepAfterRouteChange: true,
                });

                this.clientInfoViewTab.checkContractsForDeletedIntegration(i);

                this.savingInformation.set(false);
                this.router.navigate(['/clients']);
              },
              error: (_error) => {
                toastMessage += ' but failed to hide client: ' + _error;
                this.savingInformation.set(false);
              },
            });
          }
          else {
            this.toastService.toastCreate(toastMessage, 'Success', {
              autoClose: false,
              keepAfterRouteChange: true,
            });

            this.clientInfoViewTab.checkContractsForDeletedIntegration(i);
            this.integrations.update(arr => arr.filter(
              (x) => x.integrationId !== i.integrationId,
            ));

            this.savingInformation.set(false);
            this.selectNewIntegration(this.integrations()[0]);
          }

        },
        error: (_error) => {
          this.toastService.toastCreate('Failed to delete integration (' + i.name + ') and client.', 'Warning', {
            autoClose: false,
          });

          this.savingInformation.set(false);
        },
      });
    }
    else {
      this.savingInformation.set(false);
    }
  }
  //#endregion

  //I think this and the updateIntegration emitter can be removed? Confusing since this is just for the Integration name dst update
  //(updateIntegration)="updateIntegration($event)"
  updateIntegration(event: Integration): void {
    this.integration.set(event);
    this.integrations.update(arr => {
      const idx = arr.findIndex(x => x.integrationId == event.integrationId);
      if (idx !== -1) {
        const updated = [...arr];
        updated[idx] = event;
        return updated;
      }
      return arr;
    });
  }

  updateIntegrationIdentifier(event: IntegrationIdentifier): void {
    this.identifiers.update(arr => {
      const idx = arr.findIndex(x => x.destinationName == event.destinationName);
      return idx !== -1 ? [...arr.slice(0, idx), event, ...arr.slice(idx + 1)] : [...arr, event];
    });

    this.clientIdentifiers.update(arr => {
      const idx = arr.findIndex(x => x.destinationName == event.destinationName);
      return idx !== -1 ? [...arr.slice(0, idx), event, ...arr.slice(idx + 1)] : [...arr, event];
    });
  }

  deleteIntegrationIdentifier(event: IntegrationIdentifier): void {

    this.savingInformation.set(true);

    this.identifierService.deleteIntegrationIdentifier(event).subscribe({
        next: (_value) => {
          
          this.identifiers.update(arr => arr.filter(x => x.destinationId != event.destinationId));
          this.clientIdentifiers.update(arr => arr.filter(x => x.destinationId != event.destinationId));
          
          this.toastService.toastCreate('Successfully deleted integration identifier (' + event.destinationName + ')', 'Success', {
            autoClose: false,
          });
          this.savingInformation.set(false);

        },
        error: (_error) => {
          this.toastService.toastCreate('Failed to delete integration identifier (' + event.destinationName + ').', 'Warning', {
            autoClose: false,
          });

          this.savingInformation.set(false);
        },
      });
  }

  updateFromHistory(event: any) {
    if (event) {
      this.selectIntegration(this.integration());
    }
  }

  //Configuration Information Methods End

  //Utility Methods Start
  checkAccess(role: string[]): boolean {
    return this.user.checkAccess(role);
  }

  goToAddIntegration(): void {
    this.router.navigate(['/add/integrationById', this.client().clientInformationId]);
  }

  goBack(): void {
    this.router.navigate(['/clients']);
  }

  updateSavingInformation(value: boolean) {
    this.savingInformation.set(value);
  }

  onTabSelect(e: MatTabChangeEvent): void {
    window.history.replaceState({}, '', `/editConfigV2/${this.client().clientInformationId}/${this.integration().integrationId}/${e.index}`);
    this.tabId = e.index;

    if (this.processViewTab != undefined) {
      this.processViewTab.showProcessDataCardView();
    }
  }

  canDeactivate(): boolean {
    if (this.editConfigTab != undefined) {
      return this.editConfigTab.canDeactivate();
    }
    return true;
  }

  getEndpointName(destId: number): string {
    return getEndpointName(destId, this.destinationEndpoints());
  }

  isValidClientId(id: string): boolean {
    return isValidClientId(id);
  }

  isValidGuid(id: string): boolean {
    return isValidGuid(id);
  }
  //Utility Methods End
}
